module.exports = __webpack_public_path__ + "img/kims_tuebingen.ffbbf03a.jpeg";